import React, { Component } from "react";
import { connect } from "react-redux";
import Store from "./../../content/Store";
import { Redirect } from "react-router-dom";
import { Paths } from "./../../constants/UrlConstants";
import contentify from "../../content/Contentify";
import style from "../../assets/css/modules/cover/cover.css";
import mediaStyle from "../../assets/css/modules/cover/MembershipInfoSaga.css";
import ShadowedContainer from "../shared/containers/ShadowedContainer";
import Article from "../shared/Article";
import HelpSection from "../shared/HelpSection";
import PromoContainer from "../shared/containers/PromoContainer";
import PromoImageCard from "../../components/shared/PromoImageCard";
import Button from "../shared/buttons/Button";
import CoverAddAPlanLink from "./CoverAddAPlanLink";

export const mapStateToProps = (state) => {
  const selectedPolicy =
    state.policyReducer && state.policyReducer.selectedPolicy;
  return {
    IsSaga: selectedPolicy && selectedPolicy.IsSaga
  };
};

export class MembershipInfoSaga extends Component {
  constructor(props) {
    super(props);
    this.onClick = this.onClick.bind(this);
  }
  static content = {
    ...Store.Cover,
    ...Store.MembershipInfoSaga,
    ...Store.Home.Cards
  };

  onClick(event) {
    event.preventDefault();
    window.open(Store.MembershipInfoSaga.MySagaUrl);
  }
  render() {
    return !this.props.IsSaga ? (
      <Redirect to={Paths.NotFound} />
    ) : (
      <React.Fragment>
        <ShadowedContainer>
          <div className="row">
            <div className="col-lg-8 col-sm-12">
              <div className={style.articleDescription}>
                <Article
                  header={this.props.content.MemInfoTitle}
                  body={this.props.content.MemInfoDescription}
                />
              </div>
            </div>
            <div className={"col-lg-4 col-sm-12 " + mediaStyle.mySagaBtn}>
              <Button
                id="MySagaBtn"
                label={this.props.content.ButtonText}
                onClick={this.onClick}
              />
            </div>
          </div>
          <hr />
          <div className="mb-3">
            <CoverAddAPlanLink />
          </div>
          <HelpSection
            HeadingLinkText={this.props.content.HelpSection.HeadingLinkText}
            HeadingLinkTo={this.props.content.HelpSection.HeadingLinkTo}
            MoreHelpLinkText={this.props.content.HelpSection.MoreHelpLinkText}
            MoreHelpLinkTo={this.props.content.HelpSection.MoreHelpLinkTo}
            HelpSet={this.props.content.HelpSection.HelpSet}
          />
        </ShadowedContainer>

        <PromoContainer>
          <PromoImageCard
            ImgSrc={this.props.content.AskMedExpert.IconSrc}
            ImgSrcMobile={this.props.content.AskMedExpert.IconSrcMobile}
            Heading={this.props.content.AskMedExpert.Heading}
            Description={this.props.content.AskMedExpert.Description}
            LinkText={this.props.content.AskMedExpert.LinkText}
            LinkTo={this.props.content.AskMedExpert.LinkTo}
            LeftImage
          />
        </PromoContainer>
      </React.Fragment>
    );
  }
}

export default connect(mapStateToProps)(contentify(MembershipInfoSaga));
